define('SC.Configuration', ['Configuration'], function NMSDesignSystemConfigurationCompat(
    ConfigurationModule
) {
    'use strict';

    // SCA 25.2 and 26.1 expose Configuration as a named AMD export.
    // Keep legacy owned extensions loading while each is migrated and tested.
    return ConfigurationModule.Configuration || ConfigurationModule;
});
